import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
`;

export const ToastItem = styled(motion.div)`
  pointer-events: auto;
  background: #1a1a1a;
  border: 1px solid
    ${({ $type, theme }) =>
      $type === 'error' ? 'rgba(255, 77, 77, 0.3)' : `rgba(${theme.accentRgb}, 0.3)`};
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #fff;
  min-width: 260px;
  max-width: 400px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
`;

export const ToastIcon = styled.span`
  color: ${({ $type, theme }) => ($type === 'error' ? '#ff4d4d' : theme.accent)};
  display: flex;
  flex-shrink: 0;
`;
